import { mergeResolutionSettings } from "../api/resolutions.js";

export const PREVIEW_SHOP = "preview.myshopify.com";

export function isPreviewMode() {
  if (typeof window === "undefined") {
    return false;
  }
  const shop = window.location.pathname.split("/").filter(Boolean)[0];
  return shop === PREVIEW_SHOP && new URLSearchParams(window.location.search).get("preview") === "1";
}

export function previewFixtures() {
  const settings = mergeResolutionSettings({
    refund: { enabled: true },
    exchange: { enabled: true, policy: "any_product" },
    storeCredit: { enabled: true, bonusPercent: 15 },
    giftCard: { enabled: false },
    discountCode: { enabled: true, bonusPercent: 10, expiresInDays: 30 },
  });
  const order = {
    id: 1001,
    name: "#1042",
    hasRefund: true,
    deadLineDays: false,
    customer: { first_name: "Ana", last_name: "Souza", default_address: { customer_id: 9 } },
    shipping_address: {
      address1: "Rua das Flores, 120",
      city: "São Paulo",
      zip: "01310-100",
      province_code: "SP",
      phone: "11999999999",
    },
    shipping_lines: [{ title: "Correios" }],
    line_items: [
      {
        sku: "CAM-01",
        name: "Camiseta Algodão / M",
        title: "Camiseta Algodão",
        variant_title: "M / Preto",
        price: "79.90",
        current_quantity: 1,
        variant_id: 11,
        product_id: 21,
        hasWarranty: true,
        image: "",
        variants: [{ id: 11, title: "M / Preto" }],
        options: [
          { name: "Tamanho", values: ["P", "M", "G"] },
          { name: "Cor", values: ["Preto", "Off-white"] },
        ],
        availableVariants: [
          { variant_id: 11, title: "M / Preto", price: "79.90", inventoryQuantity: 4, product_id: 21, sku: "CAM-M-PRETO", selectedOptions: [{ name: "Tamanho", value: "M" }, { name: "Cor", value: "Preto" }] },
          { variant_id: 12, title: "G / Preto", price: "79.90", inventoryQuantity: 2, product_id: 21, sku: "CAM-G-PRETO", selectedOptions: [{ name: "Tamanho", value: "G" }, { name: "Cor", value: "Preto" }] },
          { variant_id: 13, title: "P / Off-white", price: "79.90", inventoryQuantity: 0, product_id: 21, sku: "CAM-P-OFF", selectedOptions: [{ name: "Tamanho", value: "P" }, { name: "Cor", value: "Off-white" }] },
          { variant_id: 14, title: "P / Preto", price: "79.90", inventoryQuantity: 3, product_id: 21, sku: "CAM-P-PRETO", selectedOptions: [{ name: "Tamanho", value: "P" }, { name: "Cor", value: "Preto" }] },
        ],
      },
      {
        sku: "MEI-02",
        name: "Meia / Único",
        title: "Meia",
        variant_title: "Único",
        price: "19.90",
        current_quantity: 1,
        variant_id: 41,
        product_id: 51,
        eligible: false,
        ineligibleReason: "Prazo de troca encerrado em 12/10.",
        variants: [{ id: 41, title: "Único" }],
        availableVariants: [],
      },
    ],
  };
  const occurrence = {
    id: 1001,
    name: "1042",
    idShopify: PREVIEW_SHOP,
    resolutionType: "exchange",
    products: [
      {
        sku: "CAM-01",
        sku_id: "CAM-01-1",
        name: "Camiseta Algodão / M",
        title: "Camiseta Algodão",
        variantTitle: "M / Preto",
        action: "Troca",
        reason: "SIZE_TOO_SMALL",
        price: 79.9,
        variant_id: 11,
        product_id: 21,
        newOrderVariantId: 12,
        dueAmount: 0,
        availableVariants: order.line_items[0].availableVariants.map((variant) => ({ ...variant })),
        options: order.line_items[0].options,
      },
    ],
    shipping_address: order.shipping_address,
  };
  return {
    store: { name: "Loja Demo" },
    storeStatus: "ready",
    resolutionSettings: settings,
    resolutionType: "exchange",
    order,
    occurrence,
    customerEmail: "ana@email.com",
    result: new URLSearchParams(window.location.search).get("status") === "1"
      ? {
        statusOccurrence: "Aguardando postagem",
        autoApproved: true,
        postReverse: {
          postCode: "AA123456BR",
          zipDestination: "01310-100",
          expireDate: "28/10/2026",
        },
      }
      : undefined,
  };
}

export const previewExchangeProducts = [
  {
    id: 44,
    product_id: 44,
    title: "Jaqueta Sarja",
    image: "",
    options: [
      { name: "Tamanho", values: ["P", "M", "G"] },
      { name: "Cor", values: ["Marrom", "Preto"] },
    ],
    variants: [
      { variant_id: 31, product_id: 44, title: "P / Marrom", sku: "JAQ-P-MAR", price: "199.00", inventoryQuantity: 1, productTitle: "Jaqueta Sarja", selectedOptions: [{ name: "Tamanho", value: "P" }, { name: "Cor", value: "Marrom" }] },
      { variant_id: 32, product_id: 44, title: "M / Marrom", sku: "JAQ-M-MAR", price: "199.00", inventoryQuantity: 0, productTitle: "Jaqueta Sarja", selectedOptions: [{ name: "Tamanho", value: "M" }, { name: "Cor", value: "Marrom" }] },
      { variant_id: 33, product_id: 44, title: "P / Preto", sku: "JAQ-P-PRETO", price: "189.00", inventoryQuantity: 2, productTitle: "Jaqueta Sarja", selectedOptions: [{ name: "Tamanho", value: "P" }, { name: "Cor", value: "Preto" }] },
    ],
  },
  {
    id: 88,
    product_id: 88,
    title: "Calça Jeans",
    image: "",
    options: [{ name: "Tamanho", values: ["38", "40", "42"] }],
    variants: [
      { variant_id: 81, product_id: 88, title: "38", sku: "CAL-38", price: "149.90", inventoryQuantity: 4, productTitle: "Calça Jeans", selectedOptions: [{ name: "Tamanho", value: "38" }] },
      { variant_id: 82, product_id: 88, title: "40", sku: "CAL-40", price: "149.90", inventoryQuantity: 0, productTitle: "Calça Jeans", selectedOptions: [{ name: "Tamanho", value: "40" }] },
      { variant_id: 83, product_id: 88, title: "42", sku: "CAL-42", price: "149.90", inventoryQuantity: 1, productTitle: "Calça Jeans", selectedOptions: [{ name: "Tamanho", value: "42" }] },
    ],
  },
  {
    id: 21,
    product_id: 21,
    title: "Camiseta Algodão",
    image: "",
    options: [
      { name: "Tamanho", values: ["P", "M", "G"] },
      { name: "Cor", values: ["Preto", "Off-white"] },
    ],
    variants: [
      { variant_id: 11, product_id: 21, title: "M / Preto", sku: "CAM-M-PRETO", price: "79.90", inventoryQuantity: 4, productTitle: "Camiseta Algodão", selectedOptions: [{ name: "Tamanho", value: "M" }, { name: "Cor", value: "Preto" }] },
      { variant_id: 12, product_id: 21, title: "G / Preto", sku: "CAM-G-PRETO", price: "79.90", inventoryQuantity: 2, productTitle: "Camiseta Algodão", selectedOptions: [{ name: "Tamanho", value: "G" }, { name: "Cor", value: "Preto" }] },
      { variant_id: 13, product_id: 21, title: "P / Off-white", sku: "CAM-P-OFF", price: "79.90", inventoryQuantity: 0, productTitle: "Camiseta Algodão", selectedOptions: [{ name: "Tamanho", value: "P" }, { name: "Cor", value: "Off-white" }] },
    ],
  },
  {
    id: 72,
    product_id: 72,
    title: "Moletom Capuz",
    image: "",
    options: [{ name: "Tamanho", values: ["P", "M"] }],
    variants: [
      { variant_id: 71, product_id: 72, title: "P", sku: "MOL-P", price: "129.90", inventoryQuantity: 3, productTitle: "Moletom Capuz", selectedOptions: [{ name: "Tamanho", value: "P" }] },
      { variant_id: 72, product_id: 72, title: "M", sku: "MOL-M", price: "129.90", inventoryQuantity: 1, productTitle: "Moletom Capuz", selectedOptions: [{ name: "Tamanho", value: "M" }] },
    ],
  },
  {
    id: 90,
    product_id: 90,
    title: "Bermuda Sarja",
    image: "",
    options: [{ name: "Tamanho", values: ["38", "40"] }],
    variants: [
      { variant_id: 91, product_id: 90, title: "38", sku: "BER-38", price: "99.90", inventoryQuantity: 2, productTitle: "Bermuda Sarja", selectedOptions: [{ name: "Tamanho", value: "38" }] },
      { variant_id: 92, product_id: 90, title: "40", sku: "BER-40", price: "99.90", inventoryQuantity: 0, productTitle: "Bermuda Sarja", selectedOptions: [{ name: "Tamanho", value: "40" }] },
    ],
  },
  {
    id: 95,
    product_id: 95,
    title: "Cinto Sarja",
    image: "",
    options: [{ name: "Tamanho", values: ["Único"] }],
    variants: [
      { variant_id: 96, product_id: 95, title: "Único", sku: "CIN-UN", price: "59.90", inventoryQuantity: 5, productTitle: "Cinto Sarja", selectedOptions: [{ name: "Tamanho", value: "Único" }] },
    ],
  },
];

